/**
 * A custom hook that processes a given class name or array of class names,
 * removes duplicates, and returns a single string of unique class names.
 *
 * @param {string | string[]} [className=''] - A string or an array of class names to process.
 * @returns {string} A string of unique class names, separated by spaces.
*/
const useClassName = (className = '') => ([
  ...new Set(
    typeof className === 'string' ?
      [className]
    :
      className
  )
].join(' ').trim());

export default useClassName;